/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import { Router } from '~/components/Router';

/**
 * Local Imports
*/

import { UserProvider } from '../../Providers';
import { IndexUser, ShowUser } from '../../Views/Users';

/**
 * Exports
*/

/**
 * 
 */
export function UserRouter(props) {
  return (
    <Router
      provider={ UserProvider }
      routes={[
        {
          path: '/:id',
          component: ShowUser
        },
        {
          path: '',
          component: IndexUser
        }
      ]}
    />
  );
}